import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a5ef906"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uppercase mb-5" }, "SELECT TOKEN", -1 /* HOISTED */))
const _hoisted_2 = { class: "tokens-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex flex-row items-center" }
const _hoisted_5 = { class: "bg-black bg-opacity-50 rounded-lg p-2" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "flex flex-col ml-2" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Cancel ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_search = _resolveComponent("search")!
  const _component_n_text = _resolveComponent("n-text")!
  const _component_repeat_outline = _resolveComponent("repeat-outline")!
  const _component_n_icon = _resolveComponent("n-icon")!
  const _component_nomad_button = _resolveComponent("nomad-button")!
  const _component_n_button = _resolveComponent("n-button")!
  const _component_n_card = _resolveComponent("n-card")!
  const _component_n_modal = _resolveComponent("n-modal")!

  return (_openBlock(), _createBlock(_component_n_modal, {
    show: _ctx.show,
    class: "bg-card",
    onMaskClick: _cache[1] || (_cache[1] = ($event: any) => (this.$emit('hide')))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_n_card, { class: "w-11/12 max-w-sm" }, {
        default: _withCtx(() => [
          _createCommentVNode(" header "),
          _hoisted_1,
          _createCommentVNode(" search bar "),
          _createVNode(_component_search, {
            onInput: _ctx.updateSearch,
            class: "mb-3"
          }, null, 8 /* PROPS */, ["onInput"]),
          _createCommentVNode(" token list "),
          _createElementVNode("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tokensFilter, (token) => {
              return (_openBlock(), _createElementBlock("div", {
                key: token.symbol,
                class: _normalizeClass(["flex flex-row items-center justify-between p-2 cursor-pointer rounded-lg hover:bg-white hover:bg-opacity-5", { disabled: _ctx.shouldSwitchToNative(token) }]),
                onClick: ($event: any) => (_ctx.select(token))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("img", {
                      src: token.icon,
                      class: "h-6 w-6"
                    }, null, 8 /* PROPS */, _hoisted_6)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(_component_n_text, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(token.symbol), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */),
                    _createVNode(_component_n_text, { class: "opacity-60 text-xs" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(token.name), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1024 /* DYNAMIC_SLOTS */)
                  ])
                ]),
                (_ctx.shouldSwitchToNative(token))
                  ? (_openBlock(), _createBlock(_component_nomad_button, {
                      key: 0,
                      class: "capitalize bg-black bg-opacity-30 text-white",
                      onClick: ($event: any) => (_ctx.switchAndSelect(token))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_n_icon, {
                          size: "18",
                          class: "mr-1"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_repeat_outline)
                          ]),
                          _: 1 /* STABLE */
                        }),
                        _createTextVNode(" " + _toDisplayString(token.nativeNetwork), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["onClick"]))
                  : _createCommentVNode("v-if", true)
              ], 10 /* CLASS, PROPS */, _hoisted_3))
            }), 128 /* KEYED_FRAGMENT */))
          ]),
          _createVNode(_component_n_button, {
            color: "#3B3B3B",
            "text-color": "#fff",
            class: "w-full mt-3 uppercase",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('hide')))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1 /* STABLE */
          })
        ]),
        _: 1 /* STABLE */
      })
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["show"]))
}